import { FormValidator, isValidCep } from '~/modules';

export const validationSchema = () =>
  FormValidator.object().shape({
    cep: FormValidator.string()
      .required('')
      .test('cep', 'Insira um CEP válido', isValidCep),
  });

export type OnboardingCepFormValues = Record<'cep', string>;

export const initialValues: OnboardingCepFormValues = {
  cep: '',
};
